import Dialog, { useDialog } from './Dialog';
import PageMain from './PageMain';
import PagePhone from './PagePhone';

interface ContactButtonProps {
  render: (props: { onClick: (e: React.MouseEvent) => void }) => React.ReactNode;
}

export default function ContactButton({ render }: ContactButtonProps) {
  const { isDialogOpen, handleOpen, handleClose, currentPage, handleGoMain, handleChangePage } =
    useDialog();

  return (
    <>
      {render({
        onClick: (e: React.MouseEvent) => {
          e.preventDefault();
          handleOpen();
        },
      })}

      <Dialog isOpen={isDialogOpen} onClose={handleClose}>
        {currentPage === 'main' && <PageMain onChangePage={handleChangePage} />}
        {currentPage === 'phone' && <PagePhone onGoBack={handleGoMain} />}
      </Dialog>
    </>
  );
}
